import store from "@/vue/planning/store/store";

// Config
import equipmentServiceFamilies from "@/config/equipmentServiceFamilies";

const getServiceDuration = (optionName: string): string | undefined => {
	if (!optionName)
		throw new Error("optionName is mandatory in getServiceDuration");
	const skipasFamilyId = "3";
	const { state } = store;
	const packageComposition: Map<string, string> = state.packageComposition;

	let duration = "";

	if (optionName === "skipass") {
		duration = packageComposition.get(skipasFamilyId) || "";
	} else if (optionName === "materiel") {
		for (const familyId of equipmentServiceFamilies) {
			const foundDuration = packageComposition.get(familyId);
			if (foundDuration) {
				duration = foundDuration;
				break;
			}
		}
	}
	return duration;
};

export default getServiceDuration;
